/**
 * 買ってもらう機能 - buy-for-me.js
 */
(function () {
  'use strict';

  var currentVariantId = null;

  function buildCartUrl(variantId) {
    return window.location.origin + '/cart/' + variantId + ':1';
  }

  function openModal(modal, url) {
    var urlEl = modal.querySelector('[id^="bfm-url-"]');
    if (urlEl) urlEl.textContent = url;
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    var closeBtn = modal.querySelector('.buy-for-me__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  function getVariantId() {
    if (currentVariantId) return currentVariantId;
    var match = location.search.match(/[?&]variant=(\d+)/);
    if (match) return match[1];
    var input = document.querySelector('input[name="id"]');
    if (input && input.value) return input.value;
    return null;
  }

  function getCurrentSizeLabel() {
    var selects = document.querySelectorAll('select[name^="options"]');
    var opts = [];
    selects.forEach(function(s) { opts.push(s.value); });
    return opts.join(' / ');
  }

  function initBuyForMe(sectionId) {
    var trigger = document.querySelector('#BuyForMe-' + sectionId + ' .buy-for-me__trigger');
    var modal = document.getElementById('BuyForMeModal-' + sectionId);
    if (!trigger || !modal) return;

    document.body.appendChild(modal);
    modal.style.display = 'none';

    currentVariantId = trigger.dataset.variantId || null;

    // select[name^="options"] のchangeを監視
    document.querySelectorAll('select[name^="options"]').forEach(function(select) {
      select.addEventListener('change', function() {
        setTimeout(function() {
          var input = document.querySelector('input[name="id"]');
          if (input && input.value) currentVariantId = input.value;
        }, 200);
      });
    });

    // URLの変化を監視
    var lastSearch = location.search;
    setInterval(function() {
      if (location.search !== lastSearch) {
        lastSearch = location.search;
        var match = location.search.match(/[?&]variant=(\d+)/);
        if (match) currentVariantId = match[1];
      }
    }, 100);

    var closeBtn = modal.querySelector('.buy-for-me__close');
    var copyBtn = modal.querySelector('#bfm-copy-btn-' + sectionId);
    var lineBtn = modal.querySelector('#bfm-line-btn-' + sectionId);

    trigger.addEventListener('click', function () {
      // URLとformから最新ID取得
      var match = location.search.match(/[?&]variant=(\d+)/);
      if (match) currentVariantId = match[1];
      var input = document.querySelector('input[name="id"]');
      if (input && input.value && !match) currentVariantId = input.value;

      var variantId = getVariantId();
      if (!variantId) return;

      // サイズラベルを更新（IDに依存しないquerySelectorで取得）
      var variantLabel = document.querySelector('[id^="bfm-variant-label-"]');
      if (variantLabel) {
        var label = getCurrentSizeLabel();
        if (label) variantLabel.textContent = label;
      }

      openModal(modal, buildCartUrl(variantId));
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () { closeModal(modal); });
    }
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal(modal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.style.display === 'flex') closeModal(modal);
    });

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var url = buildCartUrl(getVariantId());
        navigator.clipboard.writeText(url).then(function () {
          copyBtn.classList.add('copied');
          copyBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> コピーしました！';
          setTimeout(function () {
            copyBtn.classList.remove('copied');
            copyBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg> URLをコピーする';
          }, 2500);
        });
      });
    }

    if (lineBtn) {
      lineBtn.addEventListener('click', function () {
        var url = buildCartUrl(getVariantId());
        var title = trigger.dataset.productTitle || 'スパイクを買ってほしい！';
        var msg = title + 'を買ってほしいです！こちらから購入できます👟\n' + url;
        window.open('https://line.me/R/msg/text/?' + encodeURIComponent(msg), '_blank', 'noopener,noreferrer');
      });
    }
  }

  function init() {
    document.querySelectorAll('[id^="BuyForMe-"]').forEach(function (el) {
      initBuyForMe(el.id.replace('BuyForMe-', ''));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();